/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiChartCrawlerFromJSON, ApiChartCrawlerToJSON, } from './ApiChartCrawler';
import { ApiChartTemplateFromJSON, ApiChartTemplateToJSON, } from './ApiChartTemplate';
import { ApiChartTypeFromJSON, ApiChartTypeToJSON, } from './ApiChartType';
import { ApiChartVisibilityFromJSON, ApiChartVisibilityToJSON, } from './ApiChartVisibility';
import { ApiDimensionFromJSON, ApiDimensionToJSON, } from './ApiDimension';
import { ApiProjectFromJSON, ApiProjectToJSON, } from './ApiProject';
export function ApiChartFromJSON(json) {
    return ApiChartFromJSONTyped(json, false);
}
export function ApiChartFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'attributes': !exists(json, 'attributes') ? undefined : json['attributes'],
        'comparison': !exists(json, 'comparison') ? undefined : json['comparison'],
        'crawler': !exists(json, 'crawler') ? undefined : ApiChartCrawlerFromJSON(json['crawler']),
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'dateDimension': !exists(json, 'dateDimension') ? undefined : ApiDimensionFromJSON(json['dateDimension']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'dimension': !exists(json, 'dimension') ? undefined : json['dimension'],
        'dimensionDecorator': !exists(json, 'dimensionDecorator') ? undefined : json['dimensionDecorator'],
        'displayOptions': !exists(json, 'displayOptions') ? undefined : json['displayOptions'],
        'having': !exists(json, 'having') ? undefined : json['having'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'includeEmpty': !exists(json, 'includeEmpty') ? undefined : json['includeEmpty'],
        'includePublisherReadyOnly': !exists(json, 'includePublisherReadyOnly') ? undefined : json['includePublisherReadyOnly'],
        'includeSubdomains': !exists(json, 'includeSubdomains') ? undefined : json['includeSubdomains'],
        'key': !exists(json, 'key') ? undefined : json['key'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'orderBy': !exists(json, 'orderBy') ? undefined : json['orderBy'],
        'project': !exists(json, 'project') ? undefined : ApiProjectFromJSON(json['project']),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'ranks': !exists(json, 'ranks') ? undefined : json['ranks'],
        'template': !exists(json, 'template') ? undefined : ApiChartTemplateFromJSON(json['template']),
        'type': !exists(json, 'type') ? undefined : ApiChartTypeFromJSON(json['type']),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'visibility': !exists(json, 'visibility') ? undefined : ApiChartVisibilityFromJSON(json['visibility']),
        'withTotals': !exists(json, 'withTotals') ? undefined : json['withTotals'],
        'yAxisKeys': !exists(json, 'yAxisKeys') ? undefined : json['yAxisKeys'],
    };
}
export function ApiChartToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'attributes': value.attributes,
        'comparison': value.comparison,
        'crawler': ApiChartCrawlerToJSON(value.crawler),
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'dateDimension': ApiDimensionToJSON(value.dateDimension),
        'description': value.description,
        'dimension': value.dimension,
        'dimensionDecorator': value.dimensionDecorator,
        'displayOptions': value.displayOptions,
        'having': value.having,
        'id': value.id,
        'includeEmpty': value.includeEmpty,
        'includePublisherReadyOnly': value.includePublisherReadyOnly,
        'includeSubdomains': value.includeSubdomains,
        'key': value.key,
        'limit': value.limit,
        'name': value.name,
        'orderBy': value.orderBy,
        'project': ApiProjectToJSON(value.project),
        'projectId': value.projectId,
        'ranks': value.ranks,
        'template': ApiChartTemplateToJSON(value.template),
        'type': ApiChartTypeToJSON(value.type),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'visibility': ApiChartVisibilityToJSON(value.visibility),
        'withTotals': value.withTotals,
        'yAxisKeys': value.yAxisKeys,
    };
}
